import React, { Component } from "react";

class ContactBar extends Component {
  render() {
    return (
      <div className="light-border overlap">
        <div className="bottom-bar">
          <div className="container-max-width">
            <div className="bottom-flex-container">
              <h2>Get in touch</h2>
              <div>
                <h6>
                  Email:&nbsp;
                  <a
                    href="mailto:jadelawstudio@gmail.com"
                    className="text-link"
                  >
                    jadelawstudio@gmail.com
                  </a>
                </h6>
                <h6>
                  Instagram:&nbsp;
                  <a
                    href="https://www.instagram.com/art.by.jade.law/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    @art.by.jade.law
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactBar;
